import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'notImageOnly',
})
export class NotImageOnlyPipe implements PipeTransform {
  transform(list :any[]) :any[] {
    if (!list || list == null) {
      return [];
    }
    // return list;
    return list.filter((row) => {
      return !row.filetype || row.filetype.indexOf('image') < 0;
    });
  }
}
